import {
  Badge,
  Box,
  Button,
  CopyButton,
  Divider,
  Fieldset,
  FileInput,
  Flex,
  Group,
  LoadingOverlay,
  Popover,
  Text,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  IconEyeSearch,
  IconFileCv,
  IconLibraryPhoto,
  IconPhotoAi,
  IconStar,
  IconStarFilled,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import { useState } from "react";
import ReactDOM from "react-dom";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { TblItemImageCommand } from "../../../../model/ProductList";
// import { uploadImage } from "../../../../api/ApiProduct";
import { useDisclosure } from "@mantine/hooks";
import { handleEditImageNew, uploadFile } from "../../../../api/ApiProduct";
import ButtonClose from "../../../../common/ButtonClose/ButtonClose";
import OpenProductTab from "../../../../components/ProductTabs";
import { useProductCreateStore } from "../../../../store/useProductCreateStore";
import { useNavigate } from "react-router-dom";
import { modals } from "@mantine/modals";
import StockPhoto from "./StockPhoto";

const initValueImage: TblItemImageCommand = {
  id: 0,
  imageCode: "", // Mã hình ảnh
  imageName: "", // Tên hình ảnh
  description: "", // Mô tả hình ảnh
  orderNumber: 0, // Số thứ tự của hình ảnh
  orgId: 0, // ID của tổ chức liên quan đến hình ảnh
  invItemId: 0, // ID của sản phẩm liên kết với hình ảnh
  image: "", // Dữ liệu hình ảnh (URL hoặc file)
  imagePath: "", // Đường dẫn của hình ảnh
  primaryImg: "N", // Xác định hình ảnh chính ("Y" cho ảnh chính, "N" cho ảnh phụ)
  creationDate: "", // Ngày tạo hình ảnh
  createdBy: "", // Người tạo hình ảnh
  lastUpdateDate: "", // Ngày cập nhật cuối cùng của hình ảnh
  lastUpdatedBy: "", // Người cập nhật cuối cùng của hình ảnh
  lastUpdateLogin: "", // Thông tin đăng nhập của lần cập nhật cuối cùng
  imageWidth: 0, // Chiều rộng của hình ảnh (pixel)
  imageHeight: 0, // Chiều cao của hình ảnh (pixel)
};

const ItemImageCommand = () => {
  const navigate = useNavigate();
  const { dataItemImage, setDataItemImage } = useProductCreateStore(); //Dùng để lưu giá trị của text ảnh cho từng group
  const [groupCount, setGroupCount] = useState(1); // Số lượng ô Group hiện tại
  //   const [dataImage, setDataImage] = useState<TblItemImageCommand[]>([]); // Lưu giữ giá trị của TextInput cho từng Group
  const [isImageChange, setIsImageChange] = useState<boolean[]>([]);
  const [isImageWidth, setIsImageWidth] = useState<number | undefined>(
    undefined
  );
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const dataItemBase = useProductCreateStore((state) => state.dataItemBase);

  const [selectedOrgIdImageType, setSelectedOrgIdImageType] = useState<
    number | null
  >(1); // Lưu giữ ID của tổ chức đã chọn cho loại hình ảnh
  //Luu trữ các tệp ảnh
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [popoverImageIndex, setPopoverImageIndex] = useState<number | null>(
    null
  );

  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [zoom, setZoom] = useState(1);

  const handleAddGroup = () => {
    setGroupCount((prevCount) => prevCount + 1);
    // Tính toán giá trị mới
    const newDataItemImage = [
      ...dataItemImage,
      {
        ...initValueImage, // Sử dụng giá trị khởi tạo
        id: dataItemImage.length + 1, // Cập nhật ID mới cho nhóm
      },
    ];

    // Gọi setDataItemImage với giá trị mới
    setDataItemImage(newDataItemImage);
  };

  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );

  const handleRemoveGroup = (index: number) => {
    setGroupCount((prevCount) => prevCount - 1);
    const newDataImage = [...dataItemImage];
    newDataImage.splice(index, 1);
    setDataItemImage(newDataImage);
  };

  const handleChangeValue = (
    value: string | number | File | null,
    index: number,
    field: string
  ) => {
    const newDataImage = [...dataItemImage];
    newDataImage[index] = {
      ...newDataImage[index],
      [field]: value,
    };

    if (field === "image") {
      setIsImageChange((prevData) => {
        const newData = [...prevData];
        newData[index] = true;
        return newData;
      });
    }

    setDataItemImage(newDataImage);
  };

  const handleChangeMainImage = (count: number) => {
    const newDataImage = dataItemImage?.map(
      (item: TblItemImageCommand, index: number) => {
        if (index === count) {
          return { ...item, primaryImg: "Y" };
        } else {
          return { ...item, primaryImg: "N" };
        }
      }
    );

    setDataItemImage(newDataImage);
  };

  const handleRemoveMainImage = (index: number) => {
    const newDataImage = [...dataItemImage];
    newDataImage[index] = {
      ...newDataImage[index],
      primaryImg: "N",
    };
    setDataItemImage(newDataImage);
  };

  // const handleSaveForm = async () => {
  //   const hasPrimaryImage = dataItemImage.some(
  //     (image: TblItemImageCommand) => image.primaryImg === "Y"
  //   );
  //   if (dataItemImage.length !== 0 && !hasPrimaryImage) {
  //     NotificationExtension.Fails(
  //       "Vui lòng chọn một ảnh làm ảnh chính trước khi lưu"
  //     );
  //     return;
  //   } else {
  //     // DÙNG CHO ẢNH ĐƠN
  //     const dataUploadImage = dataItemImage.map(
  //       (item: TblItemImageCommand) => ({
  //         Width: item.imageWidth,
  //         Height: item.imageHeight,
  //         image: item.image,
  //         TableName: "tblItem",
  //       })
  //     );
  //     //   Dùng cho list ảnh
  //     const dataUploadListImage = dataItemImage.map(
  //       (item: TblItemImageCommand) => ({
  //         imageCode: item.imageCode,
  //         image: item.image,
  //         TableName: "tblItem",
  //       })
  //     );

  //     //   open();
  //     console.log("dataUploadListImage", dataUploadListImage);
  //     //   const res = await uploadImageList(dataUploadListImage);
  //     const res = await uploadImage(dataUploadListImage);
  //     console.log("res", res);
  //     const urlImage = res.data;
  //     console.log("urlImage", urlImage, typeof urlImage);
  //     if (res?.success && typeof urlImage === "string") {
  //       console.log("urlImage,", urlImage);
  //       const dataSubmit = dataItemImage.map((item: TblItemImageCommand) => ({
  //         ...item,
  //         id: item.id || 0, // ID mới sẽ được tạo khi lưu
  //         image: urlImage, // Cập nhật đường dẫn hình ảnh
  //         itemCode: item.imageName || "", // Sử dụng imageName làm itemCode
  //         invItemId: dataItemBase?.id,
  //       }));
  //       console.log("dataSubmit", dataSubmit);
  //       await handleUpdateImageCommand(dataSubmit);
  //     }
  //     close();
  //   }
  // };

  const handleSaveForm = async () => {
    const hasPrimaryImage = dataItemImage.some(
      (image: TblItemImageCommand) => image.primaryImg === "Y"
    );
    if (dataItemImage.length !== 0 && !hasPrimaryImage) {
      NotificationExtension.Fails(
        "Vui lòng chọn một ảnh làm ảnh chính trước khi lưu"
      );
      return;
    } else {
      // console.log("dataItemBase", dataItemBase);
      // console.log("dataItemImage", dataItemImage);
      const dataSubmit = dataItemImage.map((item: TblItemImageCommand) => ({
        ...item,
        id: item.id || 0, // ID mới sẽ được tạo khi lưu
        image: item.image, // Cập nhật đường dẫn hình ảnh
        // itemCode: item.imageName || "", // Sử dụng imageName làm itemCode
        itemCode: dataItemBase?.itemCode || "",
        invItemId: dataItemBase?.id,

        // Chỉ nối "khach_hang_" nếu chưa có ở đầu imageName // Sửa imageName cho orgId === 2
        imageName:
          item.orgId === 2
            ? item.imageName?.startsWith("khach_hang_")
              ? item.imageName
              : `khach_hang_${item.imageName}`
            : item.imageName,
      }));
      open();
      setDataItemImage(dataSubmit);
      await handleUpdateImageCommand(dataSubmit);
      close();
    }
  };

  const handleUpdateImageCommand = async (data: TblItemImageCommand[]) => {
    try {
      // Gọi API để cập nhật dữ liệu hình ảnh
      const response = await handleEditImageNew(data);
      // console.log("responseUpdateImage", response);
      if (response && response.success) {
        NotificationExtension.Success("Cập nhật hình ảnh thành công");
      }
    } catch (error) {
      console.error("Error updating image command:", error);
    }
  };

  const getObjectURL = (image: string | File | null): string => {
    if (image instanceof File) {
      return URL.createObjectURL(image);
    } else return image as string;
  };

  const valueFileInput = (image: string | File | null): File | null => {
    if (image instanceof File) {
      return image;
    } else return null;
  };

  const getWidthImage = (url: string): Promise<number> => {
    return new Promise<number>((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.addEventListener("load", function () {
        const width = this.width;
        resolve(width);
      });
      img.addEventListener("error", function () {
        reject(new Error("Failed to load image."));
      });
    });
  };

  const handleFileChange = async (files: File[] | File | null) => {
    if (!files) {
      console.error("No files selected");
      return;
    }
    // Nếu chỉ chọn 1 file, chuyển thành mảng
    const fileArray = Array.isArray(files) ? files : [files];
    setSelectedFiles(fileArray);
    // try {
    const response = await uploadFile(fileArray, "productDetail");
    if (response && response.success) {
      // response.data là mảng các url ảnh
      const newItems = response.data.map((img: any) => ({
        ...initValueImage,
        id: 0,
        image: img.url,
        imageName: img.pathNameBefore,
        orgId: selectedOrgIdImageType || 0,
      }));
      const newDataItemImage = [...dataItemImage, ...newItems];
      setGroupCount(newDataItemImage.length);
      setDataItemImage(newDataItemImage);
    }
    // } catch (error) {
    //   console.log("error", error);
    // }
  };

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
    let newZoom = zoom;
    if (e.deltaY < 0) {
      newZoom = Math.min(zoom + 0.1, 5); // Giới hạn zoom tối đa x5
    } else {
      newZoom = Math.max(zoom - 0.1, 0.2); // Giới hạn zoom tối thiểu x0.2
    }
    setZoom(Number(newZoom.toFixed(2)));
  };

  const handleClosePreview = () => {
    setPreviewImage(null);
    setZoom(1);
  };

  const changeImageAlbumType = (imageIndex: number, orgId: number) => {
    if (imageIndex < 0 || imageIndex >= dataItemImage.length) return;

    if (dataItemImage[imageIndex].orgId !== orgId) {
      const newDataImage = [...dataItemImage];
      newDataImage[imageIndex] = {
        ...newDataImage[imageIndex],
        orgId: orgId,
      };

      setDataItemImage(newDataImage);
      setPopoverImageIndex(null); // Only close the popover when album type changes
    }
    // If the same album type is selected, keep the popover open
  };

  const modalsStockPhoto = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Kho ảnh có sẵn</Title>,
      size: "auto",
      children: (
        <StockPhoto dataImage={dataItemImage} addImage={setDataItemImage} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Render preview image as portal to body
  const renderPreviewImage = () => {
    if (!previewImage) return null;
    return ReactDOM.createPortal(
      <Box
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.9)",
          zIndex: 2000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: zoom !== 1 ? "grab" : "zoom-out",
          overflow: "hidden",
        }}
        onClick={handleClosePreview}
        onWheel={handleWheel}
      >
        <img
          src={previewImage}
          alt="Preview"
          style={{
            width: "100vw",
            height: "100vh",
            objectFit: "contain",
            display: "block",
            margin: 0,
            padding: 0,
            background: "transparent",
            border: "none",
            borderRadius: 0,
            boxShadow: "none",
            cursor: zoom !== 1 ? "grab" : "zoom-out",
            transform: `scale(${zoom})`,
            transition: "transform 0.15s cubic-bezier(.4,2,.6,1)",
          }}
          onClick={(e) => e.stopPropagation()}
          draggable={false}
        />
        <Button
          style={{ position: "absolute", top: 30, right: 40, zIndex: 2100 }}
          color="red"
          onClick={handleClosePreview}
        >
          Đóng
        </Button>
        <Box
          style={{
            position: "absolute",
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: "center",
            color: "#fff",
            fontSize: 16,
            pointerEvents: "none",
          }}
        >
          Zoom: {Math.round(zoom * 100)}%
        </Box>
      </Box>,
      document.body
    );
  };

  // console.log("dataItemImage", dataItemImage);
  //   console.log("groupCount", groupCount);
  //   console.log("Files to upload:", selectedFiles);

  // Function to render an image item
  const renderImageItem = (item: TblItemImageCommand, index: number) => {
    return (
      <div
        key={item.id || `group-${index}`}
        style={{
          border: "1px solid #e9ecef",
          borderRadius: "0.5rem",
          background: "#f8fafc",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: 220,
          boxShadow: "0 1px 4px 0 rgba(0,0,0,0.04)",
          padding: "1rem",
          width: 220,
          marginBottom: 10,
          flex: "0 0 auto",
        }}
      >
        <Flex direction={"column"} justify={"center"}>
          <div
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              overflow: "hidden",
              textAlign: "center",
              borderRadius: 6,
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 8,
              boxShadow: "0 1px 4px 0 rgba(0,0,0,0.06)",
              cursor: item.image ? "pointer" : "default",
            }}
            onClick={() =>
              item.image && setPreviewImage(getObjectURL(item.image))
            }
          >
            {item.image ? (
              <img
                height={100}
                width={160}
                src={getObjectURL(item.image)}
                alt={item.imageName?.toString() || "Ảnh sản phẩm"}
                style={{
                  objectFit: "contain",
                  maxWidth: "100%",
                  maxHeight: "100%",
                }}
              />
            ) : (
              <Box></Box>
            )}
          </div>
        </Flex>
        <Flex gap={6} align="center" mb={6} style={{ width: "100%" }}>
          <TextInput
            label="STT"
            size="xs"
            style={{ flex: 1 }}
            onChange={(e) =>
              handleChangeValue(
                e.target.value,
                dataItemImage.indexOf(item),
                "orderNumber"
              )
            }
            value={item.orderNumber?.toString()}
          />
          <Tooltip label={item.imageName?.toString() || ""}>
            <TextInput
              label="Alt"
              placeholder="Alt của ảnh..."
              size="xs"
              style={{ flex: 2 }}
              onChange={(e) =>
                handleChangeValue(
                  e.target.value,
                  dataItemImage.indexOf(item),
                  "imageName"
                )
              }
              value={item.imageName?.toString()}
            />
          </Tooltip>
        </Flex>
        <Flex
          gap={16}
          mt={2}
          align="center"
          justify="center"
          style={{ width: "100%" }}
        >
          {item.primaryImg === "Y" ? (
            <Flex align="center" gap={4} style={{ color: "#f59e42" }}>
              <IconStarFilled size={18} color="#f59e42" />
              <Text
                color="red"
                fw={600}
                style={{ cursor: "pointer", fontSize: 13 }}
                onClick={() =>
                  handleRemoveMainImage(dataItemImage.indexOf(item))
                }
              >
                Ảnh chính
              </Text>
            </Flex>
          ) : (
            <Flex
              align="center"
              gap={4}
              style={{ color: "#3598dc", cursor: "pointer" }}
              onClick={() => handleChangeMainImage(dataItemImage.indexOf(item))}
            >
              <IconStar size={18} color="#3598dc" />
              <Text color="#3598dc" fw={600} style={{ fontSize: 13 }}>
                Chọn chính
              </Text>
            </Flex>
          )}

          <Popover
            position="bottom"
            shadow="md"
            opened={popoverImageIndex === dataItemImage.indexOf(item)}
            withinPortal
            trapFocus
            closeOnEscape
            onClose={() => setPopoverImageIndex(null)}
          >
            <Popover.Target>
              <Tooltip label="Chọn lại album">
                <Flex
                  align="center"
                  gap={4}
                  style={{ color: "#e03131", cursor: "pointer" }}
                  onClick={() =>
                    setPopoverImageIndex(dataItemImage.indexOf(item))
                  }
                >
                  <IconPhotoAi size={16} color="blue" />
                </Flex>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <Flex direction="column" gap="sm">
                <Text fw={500} size="sm">
                  Chọn album mới :
                </Text>
                <Flex gap="sm">
                  <Button
                    size="xs"
                    variant={item.orgId === 1 ? "filled" : "outline"}
                    color={item.orgId === 1 ? "blue" : "gray"}
                    onClick={() =>
                      changeImageAlbumType(dataItemImage.indexOf(item), 1)
                    }
                  >
                    {item.orgId === 1 ? "✓ Hình sản phẩm" : "Hình sản phẩm"}
                  </Button>
                  <Button
                    size="xs"
                    variant={item.orgId === 2 ? "filled" : "outline"}
                    color={item.orgId === 2 ? "blue" : "gray"}
                    onClick={() =>
                      changeImageAlbumType(dataItemImage.indexOf(item), 2)
                    }
                  >
                    {item.orgId === 2 ? "✓ Khách hàng chụp" : "Khách hàng chụp"}
                  </Button>
                  <Button
                    size="xs"
                    variant={item.orgId === 3 ? "filled" : "outline"}
                    color={item.orgId === 3 ? "blue" : "gray"}
                    onClick={() =>
                      changeImageAlbumType(dataItemImage.indexOf(item), 3)
                    }
                  >
                    {item.orgId === 3 ? "✓ Hacom tự chụp" : "Hacom tự chụp"}
                  </Button>
                </Flex>
              </Flex>
            </Popover.Dropdown>
          </Popover>
          <Tooltip label="Xóa ảnh">
            <Flex
              align="center"
              gap={4}
              style={{ color: "#e03131", cursor: "pointer" }}
              onClick={() => handleRemoveGroup(dataItemImage.indexOf(item))}
            >
              <IconTrash size={16} color="#e03131" />
              {/* <Text color="red" style={{ fontSize: 13 }}>
              Xóa
            </Text> */}
            </Flex>
          </Tooltip>
        </Flex>
      </div>
    );
  };
  const onNavigateOnWeb = () => {
    window.open(`${hacomUrl}/${dataItemBase?.url}`, "_blank");
  };
  return (
    <Box
      className="flex-none"
      component="form"
      mx="10px"
      style={{ position: "relative" }}
      mt={10}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />

      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 20,
          overflowY: "auto",
          overflowX: "hidden",
          background: "#fff",
        }}
      >
        {/* Ảnh sản phẩm album */}
        <Flex justify={"space-between"} align={"center"}>
          <CopyButton value={String(dataItemBase?.itemName)} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip
                label={copied ? "Đã sao chép" : "Sao chép"}
                withArrow
                position="right"
              >
                <Badge
                  color={copied ? "teal" : "blue"}
                  onClick={copy}
                  style={{ cursor: "pointer" }}
                  size="lg"
                >
                  {dataItemBase?.itemName}
                </Badge>
              </Tooltip>
            )}
          </CopyButton>
        </Flex>
        {dataItemImage?.filter(
          (item: TblItemImageCommand) => item.orgId !== 2 && item.orgId !== 3
        ).length > 0 && (
          <>
            <Text
              fw={700}
              size="md"
              style={{
                color: "#3598dc",
                borderBottom: "2px solid #3598dc",
                paddingBottom: 5,
              }}
            >
              Ảnh sản phẩm (
              {
                dataItemImage?.filter(
                  (item: TblItemImageCommand) =>
                    item.orgId !== 2 && item.orgId !== 3
                ).length
              }
              )
            </Text>
            <Flex style={{ flexWrap: "wrap", gap: 20 }}>
              {dataItemImage
                .filter(
                  (item: TblItemImageCommand) =>
                    item.orgId !== 2 && item.orgId !== 3
                )
                .map((item: TblItemImageCommand, index: number) =>
                  renderImageItem(item, index)
                )}
            </Flex>
          </>
        )}

        {/* Album Khách hàng chụp */}
        {dataItemImage?.filter((item: TblItemImageCommand) => item.orgId === 2)
          .length > 0 && (
          <>
            <Text
              fw={700}
              size="md"
              style={{
                color: "#2c3e50",
                borderBottom: "2px solid #2c3e50",
                paddingBottom: 5,
                marginTop: 15,
              }}
            >
              Khách hàng chụp (
              {
                dataItemImage?.filter(
                  (item: TblItemImageCommand) => item.orgId === 2
                ).length
              }
              )
            </Text>
            <Flex style={{ flexWrap: "wrap", gap: 20 }}>
              {dataItemImage
                .filter((item: TblItemImageCommand) => item.orgId === 2)
                .map((item: TblItemImageCommand, index: number) =>
                  renderImageItem(item, index)
                )}
            </Flex>
          </>
        )}

        {/* Album Hacom tự chụp */}
        {dataItemImage?.filter((item: TblItemImageCommand) => item.orgId === 3)
          .length > 0 && (
          <>
            <Text
              fw={700}
              size="md"
              style={{
                color: "#8e44ad",
                borderBottom: "2px solid #8e44ad",
                paddingBottom: 5,
                marginTop: 15,
              }}
            >
              Hacom tự chụp (
              {
                dataItemImage?.filter(
                  (item: TblItemImageCommand) => item.orgId === 3
                ).length
              }
              )
            </Text>
            <Flex style={{ flexWrap: "wrap", gap: 20 }}>
              {dataItemImage
                .filter((item: TblItemImageCommand) => item.orgId === 3)
                .map((item: TblItemImageCommand, index: number) =>
                  renderImageItem(item, index)
                )}
            </Flex>
          </>
        )}

        {dataItemImage.length === 0 && (
          <Text
            fw={500}
            size="md"
            style={{ textAlign: "center", color: "#999", padding: 20 }}
          >
            Chưa có ảnh nào được thêm. Vui lòng thêm ảnh bên dưới.
          </Text>
        )}

        <Fieldset legend="Thêm ảnh cho sản phẩm">
          {/* <Text size="md" variant="text" style={{ color: "red" }} fw={600}>
            Chú ý: Bạn có thể thêm nhiều ảnh cùng một lúc.{" "}
          </Text> */}
          <Flex direction={"row"} gap="sm" mt={5} align={"center"}>
            <Text>Thêm ảnh cho loại: </Text>
            <Button
              variant={`${selectedOrgIdImageType === 1 ? "filled" : "default"}`}
              onClick={() => setSelectedOrgIdImageType(1)}
            >
              Hình sản phẩm
            </Button>
            <Button
              variant={`${selectedOrgIdImageType === 2 ? "filled" : "default"}`}
              onClick={() => setSelectedOrgIdImageType(2)}
            >
              Khách hàng chụp
            </Button>
            <Button
              variant={`${selectedOrgIdImageType === 3 ? "filled" : "default"}`}
              onClick={() => setSelectedOrgIdImageType(3)}
            >
              Hacom tự chụp
            </Button>
          </Flex>
          <Flex direction={"row"} gap={"sm"} align={"end"} mt={5}>
            <FileInput
              label={`Chọn tệp (${
                selectedFiles.length > 0
                  ? `${selectedFiles.length} tệp được chọn`
                  : "Chưa có tệp nào được chọn"
              })`}
              placeholder="Chọn tệp..."
              multiple
              accept="image/png,image/jpeg"
              onChange={(files) => handleFileChange(files)}
              w={300}
            />
            <Text fw={500} size="sm">
              hoặc
            </Text>
            <Button
              variant="outline"
              color="#15AABF"
              leftSection={<IconLibraryPhoto size={16} />}
              onClick={() => modalsStockPhoto()}
            >
              Kho ảnh có sẵn
            </Button>
          </Flex>
          {/* Thông báo dung lượng ảnh đã chọn và còn lại */}
          <Box mt={4} mb={2}>
            {(() => {
              const maxSizeMB = 50;
              const totalSize = selectedFiles.reduce(
                (acc, file) => acc + file.size,
                0
              );
              const totalSizeMB = (totalSize / (1024 * 1024)).toFixed(2);
              const availableMB = (maxSizeMB - parseFloat(totalSizeMB)).toFixed(
                2
              );
              return (
                <Text
                  fw={700}
                  size="sm"
                  color={parseFloat(totalSizeMB) > maxSizeMB ? "red" : "blue"}
                >
                  Bạn đã chọn {totalSizeMB}MB / 50MB. Dung lượng còn lại:{" "}
                  {availableMB}MB.
                  <br />
                  <span
                    style={{
                      color:
                        parseFloat(totalSizeMB) > maxSizeMB
                          ? "#e03131"
                          : "#3598dc",
                    }}
                  >
                    Lưu ý: Tổng dung lượng ảnh tải lên tối đa là 50MB.
                  </span>
                </Text>
              );
            })()}
          </Box>
          <div style={{ marginTop: "5px" }}>
            <Text fw={400}>
              - Ảnh Sản phẩm kích thước lớn sẽ được tự động co lại thành các ảnh
              nhỏ hơn cho những vị trí liên quan.
              <br />
              - Tùy giao diện website của bạn mà kích thước ảnh Sản phẩm khác
              nhau.
              <br />
              - Chỉ dùng file ảnh đuôi .jpg và .gif.
              <br />- Cập nhật hình ảnh cho Sản phẩm ở nhiều góc cạnh, màu sắc
              để người dùng xem rõ nhất. Nên cập nhật ảnh có kích thước lớn và
              độ phân giải cao.
            </Text>
          </div>
        </Fieldset>

        <Group
          justify="flex-end"
          mt="lg"
          w={"100%"}
          bg={"rgba(255, 255, 255, 0)"}
          style={{
            position: "fixed",
            bottom: 10,
            right: 17.5,
            margin: "0px 75px",
          }}
        >
          <Button
            type="button"
            color="#3598dc"
            leftSection={<IconEyeSearch size={18} />}
            onClick={() => onNavigateOnWeb()}
            variant="filled"
          >
            Xem trên web
          </Button>
          <OpenProductTab
            productId={dataItemBase?.id}
            itemCode={dataItemBase?.itemName ?? ""}
            tabToOpen="info7"
            buttonText="Mở trang tab"
            variant="filled"
          />
          <Button
            type="button"
            color="#3598dc"
            variant="filled"
            onClick={() => {
              handleSaveForm();
            }}
          >
            Lưu
          </Button>
          <Button
            color="red"
            onClick={() => {
              navigate(-1);
            }}
            leftSection={<IconX size={18} />}
            variant="filled"
          >
            Đóng
          </Button>
        </Group>

        {/* Modal preview ảnh lớn */}
        {renderPreviewImage()}
      </Box>
    </Box>
  );
};

export default ItemImageCommand;
